export default "/images/6bcfb89d51aff2ec7ebc8e4a7dbf3534.avif";